var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import '@styles/webdesktop/stylesheets/contextMenuItemActions.scss';
import React, { forwardRef } from 'react';
import { SvgIcon } from '../../SvgIcon/SvgIcon';
import { Typography } from '../../Typography/Typography';
import { TypographyLevel } from '../../Typography/TypographyLevel';
import { Size, Spacing } from '@front/sharedcomponents/Variables';
import { Style, StyleContext, StyleState } from '../../../Style';
import { Stack } from '../../Stack/Stack';
import { TooltipDecorator } from '../../Tooltip/TooltipDecorator';
export const ContextMenuItemActions = forwardRef((_a, ref) => {
    var { text, actions, size = Size.Medium, checked = false, onClick } = _a, restProps = __rest(_a, ["text", "actions", "size", "checked", "onClick"]);
    const handleMainClick = () => {
        onClick === null || onClick === void 0 ? void 0 : onClick();
    };
    const handleMainKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleMainClick();
        }
    };
    const handleActionKeyDown = (e, action) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            action.onClick();
        }
    };
    const groupClassNames = [
        'context-menu-item-actions',
        size,
        Style.Secondary,
        StyleContext.ListItem,
        checked ? StyleState.Checked : ''
    ];
    const groupClassName = groupClassNames.filter(Boolean).join(' ');
    return (React.createElement("li", Object.assign({ role: "none", ref: ref }, restProps),
        React.createElement("fieldset", { "aria-label": text, className: groupClassName },
            React.createElement("div", { role: "menuitem", className: "context-menu-item-actions-text", tabIndex: 0, onClick: handleMainClick, onKeyDown: handleMainKeyDown },
                React.createElement(Typography, { level: TypographyLevel.BodyMd, noWrap: true }, text)),
            React.createElement(Stack, { className: "context-menu-item-actions-container", direction: "row", justify: "flex-end", align: "center", spacing: Spacing.Medium }, actions.map((action) => (React.createElement(TooltipDecorator, { key: action.id, content: action.title },
                React.createElement("div", { role: "menuitem", className: "context-menu-item-actions-container-action", tabIndex: 0, onClick: () => {
                        action.onClick();
                    }, onKeyDown: (e) => {
                        handleActionKeyDown(e, action);
                    }, "aria-label": action.title },
                    React.createElement(SvgIcon, { icon: action.icon })))))))));
});
